/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */

'use strict';
var searchPartMixin = require('od-modules/mixins/searchpart.mixin');
var AirportSelectorView = require('od-modules/views/airport_selector.view');
var DateSelectorView = require('od-modules/views/date_selector.view');
var trackingUtils = require('od-modules/utils/tracking.utils.js');

Odigeo.defineWidget('itinerary_search_manager', Odigeo.Widget.extend({
    modelClass: Odigeo.Model.extend(searchPartMixin.extend({
        defaults: {
            searchSegments: [],
        },

        bindCustomEvents: function(searchModel) {
            this.searchModel = searchModel;
        },

        isOneWay: function() {
            return this.searchModel.get('type') === 'oneWayTrip';
        },
    })),

    viewClass: Odigeo.View.extend({

        selectors: {
            'origin': '#origin_field_container',
            'destination': '#destination_field_container',
            'departureDate': '#depart_date_field_container',
            'returnDate': '#return_date_field_container',
            'returnDateRow': '.return_date_row_container',
        },

        trackingMap: {
            '#origin_field_container': 'orig',
            '#destination_field_container': 'dest',
            '#depart_date_field_container': 'dep',
            '#return_date_field_container': 'ret',
        },

        dateFocusControllerMap: {
            '#depart_date_field_container': 'returnDateView',
            '#return_date_field_container': 'departureDateView',
        },

        init: function() {
            this.departureAirportView = this.createAirportSelectorView('DEPARTURE');
            this.destinationAirportView = this.createAirportSelectorView('ARRIVAL');
            this.departureDateView = this.createDateSelectorView('departureDate');
            this.returnDateView = this.createDateSelectorView('returnDate');
            this.setErrorMapping();
            this.bindEvents();

            this.childrenView = [
                this.departureAirportView,
                this.destinationAirportView,
                this.departureDateView,
                this.returnDateView,
            ];
        },

        bindEvents: function() {
            this.listenTo(this.model, 'sync:fetch', this.setSearchSegmentsFromSessionStorage);
            this.listenTo(this.model, 'update', this.updateSearchSegments);
            this.listenTo(this.model, 'error', this.onErrorHandler);
            this.listenTo(this.model.searchModel, 'change:type', this.onTypeChange);
        },

        errorMapObj: function(objName, errorName) {
            return {
                obj: objName,
                showError: errorName,
            };
        },

        setErrorMapping: function() {
            this.errorsMap = {
                'date': [this.errorMapObj('departureDateView', 'triggerError'), this.errorMapObj('returnDateView', 'triggerError')],
                'departure': [this.errorMapObj('departureAirportView', 'showError'), this.errorMapObj('departureAirportView', 'showError')],
                'destination': [this.errorMapObj('destinationAirportView', 'showError'), this.errorMapObj('destinationAirportView', 'showError')],
            };
        },

        createAirportSelectorView: function(type) {
            var selector = type === 'DEPARTURE' ? 'origin' : 'destination';
            var callbacks = {
                onFocus: Odigeo._.bind(this.focusHandler, this),
            };
            return new AirportSelectorView({
                el: this.selectors[selector],
                departureOrArrival: type,
                placeholder: this.widget.options.placeholders[selector],
                tabIndex: {
                    'origin': 0,
                    'destination': 1,
                }[selector],
                errorMessages: this.widget.options.errorMessages,
                callbacks: callbacks,
                parent: this,
                showNearestLocations: this.widget.options.showNearestLocations,
            });
        },

        getCalendarType: function() {
            return this.model.isOneWay() ? 'single' : 'dual';
        },

        createDateSelectorView: function(type) {
            var index = type === 'departureDate' ? 0 : 1;
            var callbacks = {
                onFocus: Odigeo._.bind(this.focusHandler, this),
            };
            return new DateSelectorView({
                el: this.selectors[type],
                format: this.widget.options.dateFormat,
                index: index,
                tabIndex: index + 2,
                calendarDaysNames: this.widget.options.calendarDaysName,
                callbacks: callbacks,
                parent: this,
                placeholder: this.widget.options.placeholders[type],
                closeButton: this.widget.options.closeButton,
                type: this.getCalendarType(),
                isCssVariationHeaderDesktop: Odigeo.AB.isCssVariationHeaderDesktop,
                errorMessages: this.widget.options.errorMessages,
            });
        },

        toggleReturnDate: function() {
            var isRoundTrip = !this.model.isOneWay();
            this.returnDateView.toggle(isRoundTrip);
            this.$el.find(this.selectors.returnDateRow).toggleClass('odf-hidden', !isRoundTrip);
            if (isRoundTrip && Odigeo._.isNull(this.returnDateView.model.get('selectedDate'))) {
                this.returnDateView.open();
            }
        },

        onTypeChange: function() {
            var searchSegments = this.model.searchModel.get('searchSegments');
            this.setSearchSegmentViewValues(searchSegments);

            this.departureDateView.updateCalendarType();
            this.returnDateView.updateCalendarType();
            this.toggleReturnDate();
        },

        onErrorHandler: function(errors) {
            if (!Odigeo._.isEmpty(errors)) {
                Odigeo._.each(errors, Odigeo._.bind(this.handleError, this));
            } else {
                this.removeErrors();
            }
        },

        removeErrors: function() {
            this.departureAirportView.removeError();
            this.destinationAirportView.removeError();
            this.departureDateView.removeError();
            this.returnDateView.removeError();
        },

        handleError: function(error) {
            var index = error.index || 0;
            var errorOpts = !Odigeo._.isUndefined(this.errorsMap[error.key]) ? this.errorsMap[error.key][index] : null;

            if (!this.model.searchModel.isSingleFlight()) {
                return;
            }

            if (!Odigeo._.isNull(errorOpts) && this.model.searchModel.get('searchSubmit') === true) {
                this[errorOpts.obj][errorOpts.showError](error.type);
            }
        },

        focusHandler: function(element) {
            const selector = '#' + element.$el.attr('id');
            this.model.searchModel.set('focused', selector);
            this.model.searchModel.set('editsearch', true);
            trackingUtils.trackEvent('searcher_flights', 'open_change_search_' + this.trackingMap[selector]);
        },

        setSearchSegmentViewValues: function(searchSegments) {
            var departure = searchSegments[0]['departure'] || {};
            var destination = searchSegments[0]['destination'] || {};
            var departureDate = Odigeo._.get(searchSegments, '[0].dateStr');
            var returnDate = Odigeo._.get(searchSegments, '[1].dateStr');

            departureDate = departureDate ? Odigeo.Utils.parseDate(departureDate) : null;
            returnDate = returnDate ? Odigeo.Utils.parseDate(returnDate) : null;

            this.departureAirportView.model.set('selectedLocation', departure);
            this.destinationAirportView.model.set('selectedLocation', destination);
            this.departureDateView.model.set('selectedDate', departureDate);
            this.returnDateView.model.set('selectedDate', returnDate);
        },

        setSearchSegmentsFromSessionStorage: function() {
            var searchSegments = this.model.searchModel.get('searchSegments');
            if (Odigeo._.isArray(searchSegments) && Odigeo._.isObject(searchSegments[0])) {
                this.onTypeChange();
                this.model.searchModel.set('editsearch', false);
            }
        },

        updateReturnDate: function(searchData) {
            searchData.returnDate = this.model.dateRange ? new Date(searchData.departureDate.getTime() + this.model.dateRange) : null;
            this.returnDateView.model.set('selectedDate', searchData.returnDate);
            this.returnDateView.updateCalendarDates();
            this.returnDateView.$datepicker.trigger('open');
        },

        fillSearchSegment: function(searchData) {
            var searchSegments = [{}, {}];
            var departureDate = searchData.departureDate;
            var returnDate = searchData.returnDate;

            searchSegments[0]['departure'] = searchSegments[1]['destination'] = searchData.departure;
            searchSegments[0]['destination'] = searchSegments[1]['departure'] = searchData.destination;
            searchSegments[0]['dateStr'] = departureDate ? Odigeo.Utils.formatDate(departureDate, 'isoDate', true) : null;
            searchSegments[1]['dateStr'] = returnDate ? Odigeo.Utils.formatDate(returnDate, 'isoDate', true) : null;
            return searchSegments;
        },

        updateSearchSegments: function() {
            if (!this.model.searchModel.isSingleFlight()) {
                return;
            }

            var searchData = {
                departure: this.departureAirportView.model.get('selectedLocation'),
                destination: this.destinationAirportView.model.get('selectedLocation'),
                departureDate: this.departureDateView.model.get('selectedDate'),
                returnDate: this.returnDateView.model.get('selectedDate'),
            };
            if (searchData.returnDate && searchData.departureDate > searchData.returnDate) {
                this.updateReturnDate(searchData);
                return;
            }
            if (searchData.departureDate && searchData.returnDate) {
                this.model.dateRange = searchData.returnDate - searchData.departureDate;
            }
            this.model.save({'searchSegments': this.fillSearchSegment(searchData)});
        },

        isEmptyOrHasError: function() {
            return Odigeo._.some(this.childrenView, function(view) {
                return view.isEmptyOrHasError();
            });
        },

        setFocus: function() {
            var view = Odigeo._.chain(this.childrenView)
                .filter(function(view) {
                    return view.isEmptyOrHasError();
                })
                .head()
                .value();

            if (view) {
                view.setFocus();
            }
        },
    }),

}));
